<script>
    import EventBus from '../event-bus';
    import VueDraggableResizable from 'vue-draggable-resizable';

    export default {
        extends: VueDraggableResizable,

        data() {
            return {
                processing: false,
            };
        },

        props: { plexipeople: Object },

        watch: {
            x(value) {
                this.left = value;
            },

            y(value) {
                this.top = value;
            },

            w(value) {
                this.width = value;
            },

            h(value) {
                this.height = value;
            },

            'plexipeople.x'(value) {
                this.left = value;
                this.x    = value;

                this.delayedReview();
            },

            'plexipeople.width'(value) {
                this.width = value;
                this.w     = value;

                this.delayedReview();
            },

            'plexipeople.height'(value) {
                this.height = value;
                this.h      = value;

                this.delayedReview();
            },
        },

        methods: {
            delayedReview() {
                let vm = this;

                if (false !== vm.processing) {
                    window.clearTimeout(vm.processing);
                }

                vm.processing = window.setTimeout(() => {
                    vm.reviewDimensions.call(vm);

                    vm.elmW = vm.width;
                    vm.elmH = vm.height;
                    vm.elmX = vm.left;
                }, 100);
            },

            deselect(e) {
                if (e.type.indexOf('touch') !== -1) {
                    this.mouseX = e.changedTouches[0].clientX;
                    this.mouseY = e.changedTouches[0].clientY;
                } else {
                    this.mouseX = e.pageX || e.clientX + document.documentElement.scrollLeft;
                    this.mouseY = e.pageY || e.clientY + document.documentElement.scrollTop;
                }

                const target = e.target || e.srcElement;

                if (! (target.classList.contains('vdr') && target.classList.contains('draggable'))) {
                    return;
                }

                this.lastMouseX = this.mouseX;
                this.lastMouseY = this.mouseY;

                const regex = new RegExp('handle-([trmbl]{2})', '');

                if (! (this.$el.contains(target) || regex.test(target.className))) {
                    if (this.enabled) {
                        this.enabled = false;

                        this.$emit('deactivated', this);
                        this.$emit('update:active', false, this);
                    }
                }
            },

            registerIntroJsStep(config) {
                if (! this.active || 'navigation' !== config.view) {
                    return;
                }

                config.instance.push({
                    element: this.$el.querySelector('.handle'),
                    intro: 'Bestimme hiermit die Größe Deiner Figur. Der\n' + 'Preis wird Dir unten angezeigt.',
                    step: 10,
                });
            },
        },

        mounted: function () {
            document.documentElement.addEventListener('mousemove', this.handleMove, true);
            document.documentElement.addEventListener('mousedown', this.deselect, true);
            document.documentElement.addEventListener('mouseup', this.handleUp, true);

            // touch events bindings
            document.documentElement.addEventListener('touchmove', this.handleMove, true);
            document.documentElement.addEventListener('touchend', this.deselect, true);
            document.documentElement.addEventListener('touchcancel', this.deselect, true);
            document.documentElement.addEventListener('touchstart', this.handleUp, true);

            this.elmX = parseInt(this.$el.style.left);
            this.elmY = parseInt(this.$el.style.top);
            this.elmW = this.$el.offsetWidth || this.$el.clientWidth;
            this.elmH = this.$el.offsetHeight || this.$el.clientHeight;

            this.reviewDimensions();
        },

        created() {
            EventBus.$on('collectIntroJsSteps', this.registerIntroJsStep);
        },

        beforeDestroy() {
            EventBus.$off('collectIntroJsSteps', this.registerIntroJsStep);
        },
    }
</script>

<style scoped lang="scss">
    @import "../assets/scss/utilities/colors";

    .vdr {
        position: absolute;
        box-sizing: border-box;
        background-size: cover;
        opacity: 0.2;

        &.active {
            opacity: 1;
            border: 1px solid $brand-primary;

            .actions {
                position: absolute;
                top: -26px;
            }

            .info {
                text-transform: uppercase;
                font-weight: bold;
                color: #fff;
                font-size: 18px;
                display: inline-block;

                li {
                    background-color: $brand-primary;
                    text-align: center;
                    margin-bottom: 1px;
                    padding: 0 3px 3px 2px;
                }
            }
        }

        &.draggable {
            cursor: -webkit-grab;
        }

        .is--indicator {
            width: 20px;
            height: 20px;
            border-radius: 10px;
            font-size: 12px;
            line-height: 18px;
            font-weight: 700;
            border: 1px solid #fff;
            display: inline-block;
        }
    }
    .handle {
        box-sizing: border-box;
        display: none;
        position: absolute;
        width: 10px;
        height: 10px;
        font-size: 1px;
        background: #EEE;
        border: 1px solid #333;
    }
    .handle-tm {
        top: -42px;
        right: 0;
        left: 0;
        margin: auto;
        cursor: n-resize;
        width: 60px;
        height: 60px;
        text-align: center;
        background: none;
        border: none;

        &:after {
            content: "\e90f";
            font-family: 'Plexipeople';
            display: inline-block;
            width: 40px;
            height: 40px;
            font-size: 35px;
            color: $brand-primary;
          text-align: center;
        }
    }

    @media only screen and (max-width: 768px) {
        /* For mobile phones: */
        [class*="handle-"]:before {
            content: '';
            left: -10px;
            right: -10px;
            bottom: -10px;
            top: -10px;
            position: absolute;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/DraggableResizeable.vue